module.exports = __webpack_public_path__ + "static/media/SIT Geeks.2ce08c92.png";